// extracted by mini-css-extract-plugin
export var container = "_i8-0";
export var content = "_i8-3";
export var customerTitle = "_i8-4";
export var empty = "_i8-5";
export var gray = "_i8-6";
export var header = "_i8-7";
export var info = "_i8-8";
export var loading = "_i8-2";
export var loadingCard = "_i8-9";
export var oneLine = "_i8-a";
export var personName = "_i8-e";
export var pillContainer = "_i8-b";
export var selected = "_i8-1";
export var text = "_i8-c";
export var twoLines = "_i8-d";
export var unread = "_i8-f";
export var unreadIndicator = "_i8-g";